import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function listHostingOrders() {
  const { data } = await axiosClient.get("/api/admin/hosting-orders");
  return unwrapApiResponse({ data });
}

export async function getHostingOrder(id) {
  const { data } = await axiosClient.get(`/api/admin/hosting-orders/${id}`);
  return unwrapApiResponse({ data });
}

export async function markHostingOrderRead(id, isRead) {
  const { data } = await axiosClient.patch(
    `/api/admin/hosting-orders/${id}/read`,
    { isRead }
  );
  return unwrapApiResponse({ data });
}

export async function deleteHostingOrder(id) {
  const { data } = await axiosClient.delete(`/api/admin/hosting-orders/${id}`);
  return unwrapApiResponse({ data });
}
